import { withFormControl, withFieldError, withFieldArrayError } from './FormHOC';
import { TextField } from './TextField';
import { TextareaField } from './TextareaField';
import { SelectField } from './SelectField';
import { AutocompleteField } from './AutocompleteField';
import { DynamicFieldArray } from './DynamicFieldArray';
import { SelectCheckbox } from './SelectCheckbox';
import { DatePickerField } from './DatePickerField';
import { CheckboxField } from './CheckboxField';

export const FormTextField = withFieldError(TextField);
export const FormTextareaField = withFieldError(TextareaField);
export const FormSelectField = withFormControl(SelectField);
export const FormAutocompleteField = withFieldError(AutocompleteField);
export const FormSelectCheckbox = withFormControl(SelectCheckbox);
export const FormFieldArray = withFieldArrayError(DynamicFieldArray);
export const FormDatePicker = withFieldError(DatePickerField);
export const FormCheckboxField = withFieldError(CheckboxField);
